export default __webpack_public_path__ + "static/media/fpa30000.0a032682.png";